module.exports = __webpack_public_path__ + "static/assets/ba9a77bb9cb19a35ab03e907a7f0a12a.png";